import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import { TPostGeneratePaystubLinkRequest } from "./postGeneratePaystubLink.schema";

export const postGeneratePaystubLink = (axios: IAxiosInstance) => {
  return async (params: TPostGeneratePaystubLinkRequest) => {
    const response = await axios.noRetry.post<IApiResponse<string>>(
      "/api/postGeneratePaystubLink",
      params
    );
    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
